var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "mx-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": _vm.startsAt.text,
      "type": "date"
    },
    model: {
      value: _vm.value[_vm.startsAt.value],
      callback: function callback($$v) {
        _vm.$set(_vm.value, _vm.startsAt.value, $$v);
      },
      expression: "value[startsAt.value]"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": _vm.endsAt.text,
      "type": "date"
    },
    model: {
      value: _vm.value[_vm.endsAt.value],
      callback: function callback($$v) {
        _vm.$set(_vm.value, _vm.endsAt.value, $$v);
      },
      expression: "value[endsAt.value]"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }